if (!customElements.get('rb-products')) {
  class RechargeProducts extends HTMLElement {
    connectedCallback() {
      document.addEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
      document.addEventListener("recharge:variant", this.onVariantChange.bind(this));
      document.addEventListener("recharge:filter", this.onFilterChange.bind(this));
    }

    disconnectedCallback() {
      document.removeEventListener('bundling-widget:ready', this.onRechargeReady.bind(this));
      document.removeEventListener("recharge:variant", this.onVariantChange.bind(this));
      document.removeEventListener("recharge:filter", this.onFilterChange.bind(this));
      this.observer?.disconnect();
    }

    onRechargeReady() {
      this.observeModal();

      setTimeout(() => {
        this.moveProducts();
        this.addButtons();
        this.updateImages();
      }, 100);
    }

    onVariantChange() {
      setTimeout(() => {
        this.moveProducts();
        this.addButtons();
        this.updateImages();
      }, 75);
    }

    onFilterChange(event) {
      setTimeout(() => {
        this.moveProducts();
        this.addButtons();
        this.updateImages();
      }, 75);
    }

    //The ReCharge bundle serves one collection for every box size, so the
    //widget keeps rendering the 6-box artwork (which carries the per-portion
    //price). Swap in the artwork of the selected size, shipped with the page
    //by as-pm-0176-products.liquid and matched by product title.
    updateImages() {
      const size = this.selectedSize();
      if (!size) {
        return;
      }

      const images = this.imagesBySize(size);
      if (!images.size) {
        return console.error('RechargeProducts', 'no images for size', size);
      }

      let missing = 0;

      document.querySelectorAll('.rb-item-img .rb-aspect-ratio img').forEach((img) => {
        if (!this.swapImage(img, images)) {
          missing += 1;
        }
      });

      if (missing) {
        console.error('RechargeProducts', `no artwork for ${missing} meal(s) in size`, size);
      }

      //Lets the modal re-render its selection with the new artwork.
      document.dispatchEvent(new CustomEvent('recharge:images'));
    }

    //ReCharge builds the per-meal "learn more" modal only when it opens, and
    //fills it from the collection the widget was initialised with. Watching its
    //port catches every way of opening it, without guessing at timings.
    observeModal() {
      if (this.observer) {
        return;
      }

      this.observer = new MutationObserver(this.updateModalImage.bind(this));
      this.observer.observe(document.getElementById('bundling-port') || document.body, {
        childList: true,
        subtree: true,
      });
    }

    updateModalImage() {
      const img = document.querySelector('.rb-modal-images-static');
      const size = this.selectedSize();
      if (!img || !size) {
        return;
      }

      this.swapImage(img, this.imagesBySize(size));
    }

    //Returns false when this meal has no artwork in this size, so the caller can
    //report it. Keeps whatever the widget rendered in that case.
    swapImage(img, images) {
      const src = images.get(img.getAttribute('alt'));
      if (!src) {
        return false;
      }

      if (img.getAttribute('src') === src) {
        return true;
      }

      //Remember the artwork ReCharge rendered: it is the one image known to
      //exist, so a size-specific file that 404s can fall back to it instead
      //of leaving a broken image behind.
      if (!img.dataset.rbFallback) {
        img.dataset.rbFallback = img.getAttribute('src');
        img.addEventListener('error', this.restoreImage);
      }

      img.setAttribute('src', src);

      return true;
    }

    selectedSize() {
      const active = document.querySelector('rb-button[active]');

      return active ? parseInt(active.getAttribute('title'), 10) : 0;
    }

    //Bound field, so repeated addEventListener calls stay deduplicated.
    restoreImage = (event) => {
      const img = event.currentTarget;
      const fallback = img.dataset.rbFallback;

      if (!fallback || img.getAttribute('src') === fallback) {
        return;
      }

      console.error('RechargeProducts', 'artwork failed to load', img.getAttribute('src'));
      img.setAttribute('src', fallback);
    };

    imagesBySize(size) {
      this.images = this.images || {};

      if (!this.images[size]) {
        const nodes = this.querySelectorAll(`[data-rb-image="${size}"]`);
        this.images[size] = new Map(Array.from(nodes, (node) => [node.dataset.title, node.dataset.src]));
      }

      return this.images[size];
    }

    moveProducts() {
      const items = document.querySelectorAll('[data-rb-item-id]');
      items.forEach(parent => {
        const id = parent.getAttribute('data-rb-item-id');
        if(!id) {
          return;
        }

        //Check if it has already a product
        if(parent.querySelector('[data-product]')) {
          return;
        }

        const product = this.querySelector(`[data-product="${id}"]`);
        if(!product) {
          return;
        }

        //Find target from Parent Div
        const target = parent.querySelector('.rb-item-img');
        if(!target) {
          return console.error('RechargeProducts', 'no item image found', id);
        }

        //Append
        const div = product.cloneNode(true);
        target.append(div);

        //Display each product
        div.removeAttribute('hidden');
      });
    }

    addButtons() {
      const buttons = document.querySelectorAll('.rb-btn-qty-plus');
      const inputs = document.querySelectorAll('.rb-input')
      buttons.forEach((button, i) => {
        if(!inputs[i]) {
          return;
        }

        const value = inputs[i].value;
        if(value === 0 || value === '0') {
          button.classList.add('rb-button-overlay')
          button.innerHTML = `<span class="tw1">+</span><span class="rb-button-atc">Ajouter</span>`

          button.addEventListener('click', (e) => button.classList.remove('rb-button-overlay'));
        }
      })
    }
  }
  customElements.define('rb-products', RechargeProducts);
}